<div class="action-toolbar-dialog">
  <div class="action-toolbar-dialog__content">
    <div class="action-toolbar-dialog__buttons-container">
      @for (action of toolbarActions; track $index) {
        <div
          class="action-toolbar-dialog__button"
          [matTooltip]="toolbarActionView(action).tooltip | translate"
          [matTooltipDisabled]="!toolbarActionView(action).disabled"
        >
          @if (action.action_type !== 'cancelRegister') {
            <button
              mat-flat-button
              color="primary"
              (click)="checkRunAction(action)"
              [disabled]="toolbarActionView(action).disabled"
            >
              <span class="bold">
                {{ action.button_text | translate }}
              </span>
            </button>
          }
          @else {
            <button mat-button
                    (click)="checkRunAction(action)"
                    color="primary"
            >
              <span class="bold">
                {{ action.button_text | translate }}
              </span>
            </button>
          }
        </div>
      }
    </div>

    @if (!isCompleted) {
      @if (showStepIndicator() && operationContainer.currentOperation.operation_steps.length - 1 > 1) {
        <app-operation-step-indicator
          [currentOperation]="operationContainer.currentOperation"
        />
      }

      @if (showValidation() && errorCount > 0) {
        <div class="action-toolbar-dialog__error-container">
          <span>
            <span class="bold error-text-medium-up">
              {{ 'TRANS__SAVE_TOOLBAR__EXIST' | translate }}
            </span>

            <span>&nbsp;</span>

            <span class="bold">
              {{errorCount}}
            </span>

            <span>&nbsp;</span>

            <span class="bold">
              {{ 'TRANS__SAVE_TOOLBAR__ERROR' | translate }}
            </span>

            <span>&nbsp;</span>

            <span class="bold error-text-medium-up">
              {{ 'TRANS__SAVE_TOOLBAR__IN_FORM' | translate }}
            </span>

            <span>&nbsp;</span>

            @if (isInvalid) {
              <span class="error-help-text">
                {{ 'TRANS__SAVE_TOOLBAR__HELP_TEXT' | translate }}
              </span>
            }
          </span>
        </div>
      }
    }
  </div>
</div>
